import type { ConfigurationPackage } from '@festina/configuration-general-types/configuration'
import type { ConfigurableServer } from '@festina-life/core'
import { useMutation } from '@tanstack/react-query'

import { ServerServices } from '../../openApiServices'
import { flattenConfigurationPackageLayersForStandardComponent } from '../metaModel/helpers'

type TriggerProps = {
  configurationPackage: ConfigurationPackage
  server: ConfigurableServer
}

export const usePublishBranchChangesets = () =>
  useMutation({
    mutationFn: ({ configurationPackage, server }: TriggerProps) => {
      const serverApi = ServerServices[server]
      if (!server || !serverApi.api.OpenAPI.BASE) {
        throw new Error(`Non configured server: ${server}`)
      }

      const flattenedPackage =
        flattenConfigurationPackageLayersForStandardComponent(
          configurationPackage,
        )

      return serverApi.api.ConfigurationChangesetsService.configurationServicePostPostBulkChangesets(
        {
          requestBody: flattenedPackage,
        },
      )
    },
  })
